import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {LoginComponent} from './pages/login.component';
import {AdminGuard} from './services/admin.guard';
import {AuthGuard} from './services/auth.guard';
import {CustomerManagementComponent, MasterManagementComponent, ProductManagementComponent, ReportManagementComponent, UserManagementComponent} from './admin';
import {ContainerComponent} from './containers/container.component';
import {AnalysisComponent, CalendarComponent, MeasureComponent, MeasureAnalysisComponent, OrderComponent, BbComponent} from './user';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    },
    {
        path: 'login',
        component: LoginComponent,
        data: {
            title: 'ログイン'
        }
    },
    {
        path: 'user',
        component: ContainerComponent,
        data: {
            title: 'メニュー'
        },
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                redirectTo: 'user/order',
                pathMatch: 'full'
            },
            {
                path: 'bb',
                component: BbComponent,
                data: {
                    title: '買取管理(貿易)'
                }
            },
            {
                path: 'order',
                component: OrderComponent,
                data: {
                    title: '買取管理'
                }
            },
            {
                path: 'analysis',
                component: AnalysisComponent,
                data: {
                    title: '分析'
                }
            },
            {
                path: 'measure',
                component: MeasureComponent,
                data: {
                    title: '計量管理'
                }
            },
            {
                path: 'measure-analysis',
                component: MeasureAnalysisComponent,
                data: {
                    title: '計量集計'
                }
            },
            {
                path: 'calendar',
                component: CalendarComponent,
                data: {
                    title: 'カレンダー'
                }
            },
            {
                path: 'customer-management',
                component: CustomerManagementComponent,
                data: {
                    title: '顧客管理'
                }
            },
            {
                path: 'product-management',
                component: ProductManagementComponent,
                data: {
                    title: '商品管理'
                }
            },
            {
                path: 'report-management',
                component: ReportManagementComponent,
                data: {
                    title: 'レポート管理'
                },
                canActivate: [AdminGuard]
            },
            {
                path: 'user-management',
                component: UserManagementComponent,
                data: {
                    title: 'ユーザ管理'
                },
                canActivate: [AdminGuard]
            },
            {
                path: 'master-management',
                component: MasterManagementComponent,
                data: {
                    title: 'マスター管理'
                },
                canActivate: [AdminGuard]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
